import React from 'react';
import PropTypes from 'prop-types';

import {
    PictureScroller
} from 'components/features';

import {
    Card, CardHeader, CardBody,
    Row, Col, Table
} from 'reactstrap';

const tdStyle = {
    width: '1px',
    whiteSpace: 'nowrap'
};

const Checklist = props => {
    return (
        <Row>
            <Col xs="12" className="mb-3 mb-md-0">
                <Card>
                    <CardHeader className="bg-dark text-center">
                        <span className="font-italic mt-1">Checklist</span>
                    </CardHeader>
                    <CardBody>
                        <Table size='sm'>
                            <tbody>
                                <tr>
                                    <td className='border-0' style={tdStyle}>
                                        {' '}
                                        <small>
                                            <strong>Vehicle Type</strong>
                                        </small>{' '}
                                    </td>
                                    <td className='border-0'>
                                        : <small>{props.vehicle}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={tdStyle}>
                                        {' '}
                                        <small>
                                            <strong>Registration Number</strong>
                                        </small>{' '}
                                    </td>
                                    <td>
                                        : <small>{props.registration}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={tdStyle}>
                                        {' '}
                                        <small>
                                            <strong>Mileage Start</strong>
                                        </small>{' '}
                                    </td>
                                    <td>
                                        : <small>{props.startMileage} KM</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={tdStyle}>
                                        {' '}
                                        <small>
                                            <strong>Mileage End</strong>
                                        </small>{' '}
                                    </td>
                                    <td>
                                        : <small>{props.endMileage} KM</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={tdStyle}>
                                        {' '}
                                        <small>
                                            <strong>Distance Covered</strong>
                                        </small>{' '}
                                    </td>
                                    <td>
                                        : <small>{props.endMileage - props.startMileage} KM</small>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                    {props.pictures.length > 0 &&
                        <CardBody>
                            <PictureScroller pictures={props.pictures} />
                        </CardBody>
                    }
                </Card>
            </Col>
        </Row>
    )
};

Checklist.propTypes = {
    vehicle: PropTypes.string,
    registration: PropTypes.string,
    startMileage: PropTypes.number,
    endMileage: PropTypes.number,
    pictures: PropTypes.array
};

export default Checklist;



// WEBPACK FOOTER //
// ./src/components/blocks/Checklist/Checklist.js